import React, { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled, { createGlobalStyle } from 'styled-components';
import useMedia from '../../../../hooks/useMedia';
import SectionHeaderSkeleton from '../../common/sectionHeader/SectionHeaderSkeleton';
import FabricSliderSkeleton from '../fabricSlider/skeleton/FabricSliderSkeleton';
import FilterSkeleton from '../filter/skeleton/FilterSkeleton.js';
import ProductSkeleton from '../product/skeleton/ProductSkeleton';

const Wrapper = styled.div`
  margin-bottom: 80px;
  .container {
    max-width: 1300px !important;
  }

  /* .filters-wrapper {
    min-height: 230px;
  } */

  .product-container {
    margin-top: 50px;
    display: grid;
    grid-template-columns: ${({ doubleGrid }) =>
      doubleGrid ? '1fr 1fr' : '1fr'};
    grid-gap: 40px;
  }

  /* Styles transition */
  .category-filters-enter {
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  }
  .category-filters-enter-active {
    transform: translateY(0);
    transition: transform 0.3s ease-in-out;
  }
  .category-filters-exit {
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  }
  .category-filters-exit-active {
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  }

  .category-filters-exit-done {
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  }

  .grid-buttons-tabletop {
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;
  }

  .fabric-skeleton-container {
    margin-right: 20px;
  }

  @media (max-width: 992px) {
    .filters-wrapper {
      min-height: 70px;
    }
  }
`;

const GlobalStyle = createGlobalStyle`
  html > body {
    overflow: ${({ open }) => (open ? 'hidden' : 'auto')};
    overflow-x: hidden;
  }

  #gorgias-chat-container {
    display: ${({ open }) => (open ? 'none' : 'auto')};
  }

  #nav-banner-mobile {
    visibility: ${({ open }) => (open ? 'hidden' : 'visible')};
    display: ${({ open }) => (open ? 'none' : 'auto')};
    transition: all 1s;
  }


  .nav-banner-container {
    transition: all 0.4s;
    position: ${({ stickyMobile }) => (stickyMobile ? 'absolute' : 'unset')};
    opacity: ${({ stickyMobile }) => (stickyMobile ? '0' : '1')};
    z-index: -1;
  }
`;

function CategorySkeleton({ doubleGrid, setDoubleGrid }) {
  const isMobile =
    typeof window !== `undefined` ? useMedia('(max-width: 992px) ') : null;

  useEffect(() => {
    if (isMobile) {
      setDoubleGrid(false);
    }
  }, [isMobile]);

  return (
    <Wrapper doubleGrid={doubleGrid}>
      <GlobalStyle stickyMobile={isMobile} open={false} />

      <div className="observable">
        <SectionHeaderSkeleton showQuizLink />
      </div>

      {isMobile ? (
        <>
          <MobileFilterWrapper className="hide-on-desktop">
            <FilterHead className="container">
              <div className="fabric-name">
                <div className="fabric-skeleton-container">
                  <Skeleton height={35} width={35} />
                </div>
                <Skeleton height={20} width={120} />
                <div style={{ position: 'absolute', right: '15px' }}>
                  <Skeleton circle="true" height={55} width={55} />
                </div>

                {/* {selectedFabric.name}{' '}
                {selectedFabric.collaborator &&
                  `by ${selectedFabric.collaborator.name}`} */}
              </div>
            </FilterHead>
          </MobileFilterWrapper>
        </>
      ) : (
        <>
          <DesktopFilterWrapper
            className="desktop-filters hide-on-mobile"
            collapsed={false}
            hideFilters={false}
          >
            <div className="filter-slider-container">
              <>
                <FilterSkeleton />

                <FabricSliderSkeleton />
              </>
            </div>
            <CollapseContainer
              hidden={false}
              title={'Hide panel'}
              collapsed={false}
              className="collapse-container"
            >
              <div className="collapse-button">
                <img
                  src="/assets/pdp/arrow-down.svg"
                  alt="arrow collapse filters"
                />
              </div>
            </CollapseContainer>
          </DesktopFilterWrapper>
        </>
      )}

      <div className="product-container container">
        {Array.from(Array(15).keys()).map((x, i) => {
          return <ProductSkeleton key={i} doubleGrid={doubleGrid} />;
        })}
      </div>
    </Wrapper>
  );
}

export default CategorySkeleton;

const CollapseContainer = styled.div`
  transition: all 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: calc(50% - 22.5px);
  bottom: -20px;
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};

  .collapse-button {
    opacity: 0.4;
    transition: all 0.3s;
    background: #ececec;
    width: 45px;
    height: ${({ collapsed }) => (collapsed ? '90px' : '45px')};
    border-radius: 45px;
    display: flex;
    justify-content: center;
    align-items: ${({ collapsed }) => (collapsed ? 'flex-end' : 'center')};

    img {
      transition: all 0.3s;
      transform: ${({ collapsed }) =>
        collapsed ? 'rotate(0deg)' : 'rotate(180deg)'};
      margin-bottom: ${({ collapsed }) => (collapsed ? '5px' : '0px')};
    }
  }
  &:hover {
    margin-bottom: ${({ collapsed }) => (collapsed ? '-25px' : '0')};
  }
`;

const FilterHead = styled.div`
  margin-bottom: 30px;
  /* cursor: pointer; */
  display: flex;
  justify-content: space-between;
  min-height: 70px;
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  align-items: center;
  opacity: 0.6;

  .settings-button {
    display: flex;
    align-items: center;
    border-left: 1px solid #ececec;
    padding: 0 25px;
  }
  .fabric-name {
    display: flex;
    align-items: center;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #2b2b2b;

    .fabric-image-head-filter {
      margin-right: 10px;
      width: 30px;
      height: 30px;
    }
  }
`;

const MobileFilterWrapper = styled.div`
  position: sticky;
  top: 59px;
  z-index: 9;
  background: white;

  .menu-fabric-enter,
  .menu-view-fabric-enter {
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
  }
  .menu-fabric-enter-active {
    transform: translateX(0);
    transition: transform 0.3s ease-in-out;
  }
  .menu-fabric-exit {
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
  }
  .menu-fabric-exit-active {
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
  }
`;

const DesktopFilterWrapper = styled.div`
  top: 0px;
  position: sticky;
  width: 100%;
  height: auto;
  background: white;
  z-index: 8;
  transition: transform 0.3s ease-in-out;

  transform: ${({ hideFilters, collapsed }) =>
    collapsed
      ? 'translateY(-100%)'
      : hideFilters
      ? 'translateY(-35%)'
      : 'translateY(0%)'};

  /* .category-filters-enter {
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  }
  .category-filters-enter-active {
    transform: translateY(0);
    transition: transform 0.3s ease-in-out;
  }
  .category-filters-exit {
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  }
  .category-filters-exit-active {
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  }

  .category-filters-exit-done {
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
  } */
`;
